"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;








































































































var _user = require("@/utils/user");
var _formatter = require("@/utils/formatter"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { data: function data() {return { tableData: [], // 列表数据
      droplist: [], title: '', newadd: false, addData: { id: '', otaVersionId: '', content: '', locale: '', localeName: '' }, defaultData: { id: '', otaVersionId: '', content: '', locale: '', localeName: '' }, searchData: { // 当前页码
        page: 1, // 页码条数
        rows: 10 }, pageData: { page: 1, rows: 10, total: 0, pages: 1 }, // 表格列
      tableColumns: [{ prop: 'localeName', label: '界面语言', isShow: true }, { prop: 'content', label: '更新内容', isShow: true }, { prop: 'updateTime', label: '更新时间', formatter: _formatter.dateFormatter, isShow: true }], rules: { content: [{ required: true, message: '请输入更新内容', trigger: 'blur' }], locale: [{ required: true, message: '请选择界面语言', trigger: 'blur' }] } };}, mounted: function mounted() {var self = this;self.getdrop();self.addData.otaVersionId = self.$route.params.parentId;self.defaultData.otaVersionId = self.$route.params.parentId;self.init();}, methods: { init: function init() {var self = this;var params = Object.assign({}, self.searchData);params.otaVersionId = self.addData.otaVersionId;self.getData('/api/faOtaVersionUpdateContent', params, function (res) {self.tableData = res.list;self.pageData.page = res.pageNum;self.pageData.total = res.total;});}, checkPermission: _user.checkPermission, handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;this.searchData.page = 1;this.init();}, handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;this.init();}, delMenu: function delMenu(item) {var self = this;self.$confirm('确定删除该记录吗？', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(function () {self.delData('/api/faOtaVersionUpdateContent/' + item.id, {}, function (res) {self.$message({ message: '删除成功!', type: 'success' });self.searchData.page = 1;self.init();});
      }).catch(function () {});
    },
    addFun: function addFun() {// 新增
      this.title = '新增';
      this.addData = JSON.parse(JSON.stringify(this.defaultData));
      this.newadd = true;
    },
    updateMenu: function updateMenu(item) {
      this.title = '修改';
      var self = this;
      this.addData = {
        id: item.id,
        locale: item.locale,
        localeName: item.localeName,
        content: item.content,
        otaVersionId: item.otaVersionId };

      self.newadd = true;
    },
    onSubmit: function onSubmit(item) {
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          self.addData.details = self.poplistData;
          self.postData('/api/faOtaVersionUpdateContent', self.addData, function (res) {
            self.$message({
              message: '新增成功!',
              type: 'success' });

            self.onCencal();
            self.searchData.page = 1;
            self.init();
          });
        } else {
          return false;
        }
      });
    },
    onUpdate: function onUpdate(item) {
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          self.addData.details = self.poplistData;
          self.postData('/api/faOtaVersionUpdateContent/', self.addData, function (res) {
            self.$message({
              message: '修改成功!',
              type: 'success' });

            self.onCencal();
            self.searchData.page = 1;
            self.init();
          });
        } else {
          return false;
        }
      });
    },
    getdrop: function getdrop() {
      var self = this;
      self.getData('/api/faDict/parentCode/locale', {}, function (res) {
        self.droplist = res;
      });
    },
    // changeproductFun: function(data) {
    //   let obj = {}
    //   obj = this.droplist.find((item) => {
    //     return item.name === data
    //   })
    //   console.log('obj',obj)
    //   this.addData.locale = obj.name
    //   this.addData.localeName = obj.type
    // },
    onCencal: function onCencal() {
      this.$refs.addForm.resetFields();
      this.newadd = false;
    },
    closeDiglog: function closeDiglog() {
      this.$refs['addForm'].resetFields();
      this.newadd = false;
    },
    returnFun: function returnFun() {
      // 返回上一级
      this.$router.push('/wifi/wifiEdition');
    } } };exports.default = _default;